const popupButtons = document.querySelectorAll('.popup-button');

popupButtons.forEach((popupButton) => {
  const popupWrapper = popupButton.closest('.shopify-section').querySelector('.popup-wrapper');
  const popup = popupWrapper.querySelector('.popup-modal');
  const closeButton = popup.querySelector('.close-button');

  popupButton.addEventListener('click', () => {
    popupWrapper.classList.remove('hidden');
    body.classList.add('modal--open');
  });

  popupWrapper.addEventListener('click', () => {
    popupWrapper.classList.add('hidden');
    body.classList.remove('modal--open');
  });

  closeButton.addEventListener('click', () => {
    popupWrapper.classList.add('hidden');
    body.classList.remove('modal--open');
  });

  popup.addEventListener('click', (e) => {
    e.stopPropagation();
  });
});
